const o = "_inputGroup_1kt2h_1", t = "_column_1kt2h_20", n = "_message_1kt2h_32", _ = "_validation_1kt2h_1", u = "_ok_1kt2h_67", a = {
  inputGroup: o,
  column: t,
  "column-background": "_column-background_1kt2h_21",
  "row-background": "_row-background_1kt2h_26",
  message: n,
  validation: _,
  ok: u
};
export {
  t as column,
  a as default,
  o as inputGroup,
  n as message,
  u as ok,
  _ as validation
};
//# sourceMappingURL=validation-message.module.less.js.map
